<script>

export default {
    name: 'InputSwitch',
    props: ['description'],
    emits: ["toggle"],
    methods: {},

    data() {
        return {}
    },

    computed:
    {
        id(){
            return "checkbox-" + Math.floor(Math.random() * 100);
        },
    },
}


</script>


<template>
    <div class="input-switch">
        <input @click="$emit('toggle')" type="checkbox" class="input-switch__checkbox" id="id">
        <label class="input-switch__switch" for="id">
            <span class="input-switch__slider"></span>
        </label>
    </div>
</template>